/* src/components/pdf-page-project-info/pdf-page-project-info.component.scss */
app-pdf-project-info {
  display: block;
}
/*# sourceMappingURL=pdf-page-project-info.component-TMG4IJL3.css.map */
